import React, { useState, useEffect } from 'react';
import styles from './UserManagementTable.module.css'; // 원하는 스타일 적용
import dayjs from 'dayjs';
import { ko } from "date-fns/locale/ko";
import DatePicker from "react-datepicker";
import { DialogEnum, showDialog } from '../../../utils/dialog/Dialog';
import { TableStateType } from '../../../utils/contextapi/TableProvider';

export const ADMINROLE = {
  SYS_ADMIN: 'SYS_ADMIN',
  ADMIN_USER: 'ADMIN_USER'
}

const UserManagementTable = ({ datas, context, detailUser, onPrevPage, onNextPage, disablePrev, disableNext, pageNumber, totalCount, listSize, searchValue, setSearchValue, onSearch, isMobileWindow }) => {
  const [selected, setSelected] = useState([]);
  const [sortField, setSortField] = useState('createdDate');
  const [sortOrder, setSortOrder] = useState('desc');
  const [searchType, setSearchType] = useState("unifiedProfileId");
  // const {openModal} = useContext(ModalContext);

  // 정렬 처리
  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortOrder('asc');
    }
  };

  const sortedDatas = [...datas].sort((a, b) => {
    let valA = a[sortField];
    let valB = b[sortField];
    // 날짜 비교
    if (sortField === "createdDate" || sortField === "lastConnectionDate") {
      valA = Number(valA) || 0;
      valB = Number(valB) || 0;
    }
    if (valA < valB) return sortOrder === "asc" ? -1 : 1;
    if (valA > valB) return sortOrder === "asc" ? 1 : -1;
    return 0;
  });

  // const currentUserId = Number(sessionStorage.getItem("id"));

  // 체크박스 관련
  // const isAllSelected = selected.length === users.length && users.length > 0;
  // const selectableIds = datas.map(u => u.id).filter(id => id !== currentUserId);
  // const isAllSelected = selectableIds.every(id => selected.includes(id));
  // const handleSelectAll = () => {
    // setSelected(isAllSelected ? [] : users.map(u => u.id));
    // const selectableIds = users.map(u => u.id).filter(id => id !== currentUserId);
  //   setSelected(isAllSelected ? [] : selectableIds);
  // };

  // const handleSelectRow = (id) => {
  //   if (id === currentUserId) return; // 제외
  //   setSelected(selected.includes(id)
  //     ? selected.filter(i => i !== id)
  //     : [...selected, id]);
  // };

  const dateView = (dateView) => { 
    const date = new Date(dateView);
    return dayjs(date).format('YYYY-MM-DD hh:mm:ss');
  };

  const handleStatusChange = (e) => {
    setSearchType(e.target.value);
  };

  const failDetail = () =>{
    showDialog(DialogEnum.FAIL, "경고", "권한이 없습니다.");
  }

  return (
    <div className={styles.tableSection}>
      <div className={styles.actionTopBar}>
        {/* 왼쪽: 검색 */}
        <div className={styles.actionBar}>
          <select name={"status"}
            className={styles.rightCont__cont__select} value={searchType}
            style={{ appearance: "auto", padding: '10px 10px', borderRadius: '4px', border: '1px solid #ccc' }}
            onChange={handleStatusChange}>
            <option value={"unifiedProfileId"} defaultValue={true}>아이디</option>
            <option value={"name"}>이름</option>
          </select>
          <input
            className={styles.rightCont__cont__search}
            type="text"
            placeholder="아이디, 이름 검색"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            style={{
              padding: '10px 20px',
              borderRadius: '4px',
              border: '1px solid #ccc'
            }}
          />
          <div className={styles.rightCont__cont__calenderWrap}>
              <DatePicker
              className={styles.rightCont__cont__calender}
              locale={ko}
              selectsRange={true}
              startDate={context.state.dateRange[0]}
              endDate={context.state.dateRange[1]}
              onChange={(update) => {
                  context.actions.contextDispatch({type: TableStateType.DATE_RANGE, data: update});
              }}
              withPortal={true}
              />
          </div>
          <button
            onClick={() => onSearch(searchType, searchValue)}
            className={styles.addBtn}
          >
            검  색
          </button>
        </div>
          <>
            {/* 오른쪽: 버튼 묶음 */}
            <div className={styles.actionBar}>
              {/* <button
                onClick={onAddUser}
                className={styles.addBtn}
              >
                테넌트 등록
              </button> */}
            </div>
          </>
      </div>
      <table className={styles.table}>
        <thead>
          <tr>
            {/* <th className={styles.checkboxCell}>
              <input
                type="checkbox"
                className={styles.userCheckbox}
                checked={isAllSelected}
                ref={el => {
                  if (el) {
                    el.indeterminate = selected.length > 0 && !isAllSelected;
                  }
                }}
                onChange={handleSelectAll}
              />
            </th> */}
            <th className={styles.idCol} onClick={() => handleSort('unifiedProfileId')} style={{ cursor: 'pointer' }}>
              아이디 명 {sortField === 'unifiedProfileId' ? (sortOrder === 'asc' ? '▲' : '▼') : ''}
            </th>
            <th className={styles.idCol} onClick={() => handleSort('name')} style={{ cursor: 'pointer' }}>
              이름 {sortField === 'name' ? (sortOrder === 'asc' ? '▲' : '▼') : ''}
            </th>
            {!isMobileWindow &&
              <th className={styles.idCol} onClick={() => handleSort('createdDate')} style={{ cursor: 'pointer' }}>
                가입일 {sortField === 'createdDate' ? (sortOrder === 'asc' ? '▲' : '▼') : ''}
              </th>
            }
          </tr>
        </thead>
        <tbody>
          {sortedDatas.map((data) => {
              const handleRowClick = () => {
                detailUser(data.unifiedProfileId);
              };
            return (
              <tr key={data.unifiedProfileId} className={styles.tableRow} 
                onClick={handleRowClick} 
                style={{ cursor: "pointer" }}
              >
                <td className={styles.idCol}>{data.unifiedProfileId}</td>
                <td className={styles.idCol}>{data.name ?? '미설정'}</td>
                {!isMobileWindow &&
                  <td className={styles.idCol}>{dateView(data.createdDate)}</td>
                }
              </tr>
            );
          })}
          {datas.length === 0 && (
            <tr>
              {!isMobileWindow ?
                (<td colSpan={3} style={{ textAlign: "center", color: "#888" }}>유저가 없습니다.</td>) :
                (<td colSpan={2} style={{ textAlign: "center", color: "#888" }}>유저가 없습니다.</td>)
              }
            </tr>
          )}
        </tbody>
      </table>
      <div className={styles.actionBarBottom} style={{ marginTop: "8px" }}>
        <>
          {totalCount > 0 && (
            <p className={styles.text} >{pageNumber * listSize + 1} - {Math.min((pageNumber * listSize + 1) + listSize - 1, totalCount)} of {totalCount} </p>
          )}
          <button className={styles.addBtn} onClick={onPrevPage} disabled={disablePrev}>{"<"}</button>
          <button className={styles.addBtn} onClick={onNextPage} disabled={disableNext}>{">"}</button>
        </>
      </div>
    </div>
  );
};

export default UserManagementTable;
